import Modal from "~/common/components/Modal";

const FUNCTIONAL_DOMAINS = [
  {
    title: "Positive self-reporting",
    text: "The patient answered both direct and indirect questions about this domain with positive words. This may indicate a high level of functioning in this domain.",
    group: "Congruent response patterns",
    className: "text-complementary-success-800",
  },
  {
    title: "Negative self-reporting",
    text: "The patient answered both direct and indirect questions about this domain with negative words. This may indicate a low level of functioning in this domain.",
    group: "Congruent response patterns",
    className: "text-complementary-error-700",
  },
  {
    title: "Possibility of self-underreporting",
    text: "The patient answered direct questions about this domain with positive words, and indirect questions with negative words. This may indicate patient minimization of difficulties in this domain.",
    group: "Incongruent response patterns",
    className: "text-complementary-warning-600",
  },
  {
    title: "Possibility of self-overreporting",
    text: "The patient answered direct questions about this domain with negative words, and indirect questions with positive words. This may indicate patient amplification of difficulties in this domain.",
    group: "Incongruent response patterns",
    className: "text-complementary-warning-600",
  },
  {
    title: "Mixed self-reporting",
    text: "The patient answered questions about this domain with a mix of positive and negative words.",
    group: "Incongruent response patterns",
    className: "text-complementary-warning-600",
  },
  {
    title: "Limited self-reporting",
    text: "The patient did not answer direct questions about this domain, and answered indirect questions with neutral words.",
    group: "Indeterminate response patterns",
    className: "text-complementary-warning-600",
  },
  {
    title: "N/A",
    text: "The patient did not answer either direct or indirect questions about this domain.",
    group: "Indeterminate response patterns",
    className: "",
  },
];

const FUNCTIONAL_DOMAINS_BY_GROUP = Object.groupBy(
  FUNCTIONAL_DOMAINS,
  ({ group }) => group,
);

export const FunctionalDomainsModalV4 = ({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) => (
  <Modal
    className="h-fit max-h-[80vh] w-auto overflow-y-auto md:min-w-[46rem]"
    titleClassName="text-2xl font-semibold text-gray-70"
    title="Functional domains"
    show={show}
    onClose={onClose}
  >
    <div className="flex flex-col gap-4 text-sm text-gray-700">
      <p>
        Functional domains are areas of a person&apos;s life that provide a
        holistic view of their overall well-being. This module is designed to
        perform structured comparison of patient-provided direct and indirect
        responses to identify cross-item response patterns within each domain.
        It does not detect, diagnose, classify, or predict mental or emotional
        states. Further exploration by a licensed clinician is required to
        assess the level of functioning in each domain.
      </p>
      {Object.keys(FUNCTIONAL_DOMAINS_BY_GROUP).map((group) => (
        <div key={group}>
          <h3 className="mb-4 text-[16px] font-semibold">{group}:</h3>
          <ul className="flex list-disc flex-col gap-4 pl-6">
            {FUNCTIONAL_DOMAINS_BY_GROUP[group]?.map((domain, idx) => (
              <li key={idx} className={domain.className}>
                <span className="font-semibold">{domain.title}:</span>{" "}
                <span className="text-gray-700">{domain.text}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </Modal>
);
